<template>
  <div class="pins-report relative">
    <div v-if="error" class="error text-center mb-2">
      {{ error }}
    </div>
    <h1 class="page-header text-center text-3xl">member pin code report</h1>
    <div class="text-center text-lg">
      analyze and download the number of members who have set <br />
      up a pin code
    </div>
    <div class="flex justify-center items-center absolute top-0 right-5">
      <div v-if="downloadReportLoading" class="flex justify-center items-center w-40 mt-3">
        <loading-icon />
      </div>
      <template v-else>
        <a v-if="downloadUrl" :href="downloadUrl" class="button larger" download>
          download report
        </a>
        <button
          v-else
          :class="{ disabled: !reportId }"
          class="button larger"
          @click="generateExport"
        >
          download report
        </button>
      </template>
    </div>
    <div class="mt-12">
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-3xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ totalMember || 0 }}
          </span>
        </div>
        <div class="text-lg w-48">total {{ totalMember > 1 ? 'members' : 'member' }}</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-2xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ optedInToSms || 0 }}
          </span>
        </div>
        <div class="text-lg w-48">opted in to sms</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ withPinCode || 0 }}
          </span>
        </div>
        <div class="text-lg w-48">with a pin code</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-xl font-medium">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else>
            {{ percentWithPin || 0 }}%
          </span>
        </div>
        <div class="text-lg w-48">
          of members who are opted in have a pin code
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoadingIcon } from '@springbig/sb-components';
import { ReportAPI } from '../../services/api/Reports';

export default {
  name: 'PinsReport',
  components: {
    LoadingIcon,
  },
  data() {
    return {
      reportId: null,
      totalMember: null,
      optedInToSms: null,
      withPinCode: null,
      percentWithPin: null,
      downloadUrl: '',
      error: null,
      loadingReport: false,
      downloadReportLoading: false,
    }
  },
  async created() {
    this.loadingReport = true;
    try {
      const { data: { report } } = await ReportAPI.createReport('Reports::MembersWithPinsReport');
      const { id, output_data } = report;
      this.reportId = id;
      this.totalMember = output_data.total_count
      this.optedInToSms = output_data.opt_in_count;
      this.withPinCode = output_data.with_pin_count;
      this.percentWithPin = output_data.percent_with_pin;
    }
    catch (error) {
      this.handleError(error);
    }
    this.loadingReport = false;
  },
  methods: {
    handleError(error) {
      this.error = error;
    },
    async checkDownloadUrlStatus() {
      try {
        const res = await ReportAPI.getReportDownloadUrl(this.reportId);
        if (res.data.report.download_url) {
          this.downloadUrl = res.data.report.download_url;
          this.downloadReportLoading = false;
          const link = document.createElement('a');
          link.href = this.downloadUrl;
          link.download = true;
          link.click();
          link.remove();
        }
        else if(res.data.report.export_state === 'failed') {
          this.handleError(new Error('report generation failed. please try again.'));
          this.downloadReportLoading = false;
        }
        else {
          setTimeout(this.checkDownloadUrlStatus, 1000);
        }
      }
      catch(error) {
        this.handleError(error);
        this.downloadReportLoading = false;
      }
    },
    generateExport() {
      if (!this.downloadUrl) {
        this.downloadReportLoading = true;
        ReportAPI.generateExportByReportId(this.reportId);
        setTimeout(this.checkDownloadUrlStatus, 1000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pins-report {
  .loading-icon {
    width: 35px!important;
  }
  .page-header {
    margin: 0;
  }
  .button {
    display: block;
    margin: 10px auto 0 auto;
    height: 30px;
    font-size: 1rem;
    padding: 5px 20px;
    color: rgba(255, 255, 255, 0.7);
    border-radius: 5px;
  }
}
</style>
